import { render, staticRenderFns } from "./EventBasunFields.vue?vue&type=template&id=acc3b044"
import script from "./EventBasunFields.vue?vue&type=script&lang=js"
export * from "./EventBasunFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports